import { isDiySignup } from '@farmersdog/lead-browser-storage';
import { Logger } from '@farmersdog/logger';

import { type ReferredByVet } from './useReferredByVetUrlParam';

const logger = new Logger('tosa:frontend:vet:validateReferredByVet');

export function validateReferredByVet(
  referredByVetParam: unknown
): ReferredByVet {
  const validReferredByVet = { ...(referredByVetParam as ReferredByVet) };

  if (typeof referredByVetParam !== 'object' || referredByVetParam === null) {
    throw new Error('Failed to parse url param');
  }

  if (
    !('dogName' in referredByVetParam) ||
    typeof referredByVetParam.dogName !== 'string'
  ) {
    validReferredByVet.dogName = '';
    logger.error('Invalid dogName in url param', {
      referredByVetParam,
    });
  }

  if (
    !('vetName' in referredByVetParam) ||
    typeof referredByVetParam.vetName !== 'string'
  ) {
    validReferredByVet.vetName = '';
    logger.error('Invalid vetName in url param', {
      referredByVetParam,
    });
  }

  if (isDiySignup()) {
    if (
      !('diyRecipeDisplayNames' in referredByVetParam) ||
      !Array.isArray(referredByVetParam.diyRecipeDisplayNames)
    ) {
      validReferredByVet.diyRecipeDisplayNames = [];
      logger.error('Invalid diyRecipeDisplayNames in url param', {
        referredByVetParam,
      });
    }
  } else {
    if (
      !('freshRecipeNames' in referredByVetParam) ||
      !Array.isArray(referredByVetParam.freshRecipeNames)
    ) {
      validReferredByVet.freshRecipeNames = [];
      logger.error('Invalid freshRecipeNames in url param', {
        referredByVetParam,
      });
    }
  }

  return validReferredByVet;
}
